import createConverter from 'scripts/application/dto_converters/lib/create_converter';
import SearchQuery from 'models/search/search_query';

export default createConverter(SearchQuery);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/search/search_query_converter.js